<div class="no-data-content" [style.min-height]="minHeight">
  <div class="no-data-item narrow">
    <svg-icon class="m-b-16" key="no-data" />
    <p>No data available for this filter option.</p>
    <p>Try a different option.</p>
  </div>
</div>
